export class Parametro {
    nparamId: Number;
    cparamDsc: string;
    cparamValor: string;
    nparamValor: number;
}

